import { PackageListProps } from "../models/PropsInterface";
import CreditPackageCol from "./CreditPackageCol";
import DefaultPackageCol from "./DefaultPackageCol";
import "../cssStyles/PackageList.css";

const PackageList = (props: PackageListProps) => {
  return props.packages ? (
    <div className={`vas-row package_list__row `}>
      {props.packages.map((pkg) => {
        return pkg.service !== "Credit" ? (
          <DefaultPackageCol
            pkg={pkg}
            domain={props.domain}
            api={props.api}
            pos_source={props.pos_source}
            referral_url={props.referral_url}
            token={props.token}
            countryAbbreviation={props.countryAbbreviation}
            source={props.source}
            modelId={props.modelId}
            setIsSuccessProcess={props.setIsSuccessProcess}
            selectedAssignId={pkg.id}
            selectedBundleId={props.selectedBundleId}
            bundles={props.bundles}
            currentBundles={props.currentBundles}
            selectedId={props.selectedId}
            setSelectedId={props.setSelectedId}
            language={props.language}
          />
        ) : (
          <CreditPackageCol
            pkg={pkg}
            api={props.api}
            domain={props.domain}
            pos_source={props.pos_source}
            referral_url={props.referral_url}
            token={props.token}
            countryAbbreviation={props.countryAbbreviation}
            source={props.source}
            modelId={props.modelId}
            setIsSuccessProcess={props.setIsSuccessProcess}
            selectedAssignId={pkg.id}
            selectedBundleId={props.selectedBundleId}
            currentBundles={props.currentBundles}
            bundles={props.bundles}
            selectedId={props.selectedId}
            setSelectedId={props.setSelectedId}
            language={props.language}
          />
        );
      })}
    </div>
  ) : (
    <div></div>
  );
};

export default PackageList;
